import React, { Component } from 'react';
import { View, Animated, Dimensions, I18nManager, FlatList } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import {
  map as _map,
  forEach as _forEach,
  isEqual as _isEqual,
  isFunction as _isFunction,
} from 'lodash';
import PropTypes from 'prop-types';

import { VFText, Tabs, VFButton } from '@vfgroup-oneplatform/foundation/Components';
import {
  withTheme,
  Metrics,
  LightThemeColors,
} from '@vfgroup-oneplatform/foundation/Components/Themes';
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';
import { Tray_Actions_Types } from '../../Utils';

import styles from './SubTrayGroup.Styles';

const cardsOpenBaseDelay = 333;
const cardsCloseBaseDelay = 0;
const cardOpenDuration = 180;
const cardCloseDuration = 100;

const screenWidth = Dimensions.get('window').width;

class SubTrayGroup extends Component {
  constructor(props) {
    super(props);

    this.cardsAnimations = [];
    this.scrollX = 0;

    this.state = {
      displayedNumberOfCards: null,
      animationType: '',
    };
  }

  componentDidMount() {
    const { items, isVisible, trayAction, isLoading } = this.props;
    const itemsExist = !!(items && items.length > 0);
    if (trayAction === 'open' && itemsExist && !isLoading) {
      this.cardsAnimations = _map(items, () => new Animated.Value(0));

      if (isVisible) {
        _forEach(this.cardsAnimations, animatedValue => {
          this.startCardAnimation(animatedValue, isVisible);
        });
      }
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps.trayAction === 'open' && this.props.trayAction !== 'open') {
      const { items, isVisible, trayAction } = nextProps;
      const itemsExist = !!(items && items.length > 0);
      const isNotificationEqual = _isEqual(
        this.props.notificationCount,
        nextProps.notificationCount,
      );
      if (trayAction === 'open' && isNotificationEqual && itemsExist) {
        this.cardsAnimations = _map(items, () => new Animated.Value(0));
        if (isVisible) {
          _forEach(this.cardsAnimations, (animatedValue, index) => {
            this.startCardAnimation(animatedValue, isVisible, index);
          });
        }
      }
    } else if (
      nextProps.trayAction === Tray_Actions_Types.CLOSE &&
      this.props.trayAction != Tray_Actions_Types.CLOSE
    ) {
      this.cardsAnimations = _map(nextProps.items, () => new Animated.Value(1));
      _forEach(this.cardsAnimations, animatedValue => {
        this.startCardAnimation(animatedValue, false);
      });
    } else if (this.props.isLoading && !nextProps.isLoading) {
      this.cardsAnimations = _map(nextProps.items, () => new Animated.Value(1));
    } else if (
      nextProps.trayAction === Tray_Actions_Types.OPEN &&
      this.props.trayAction === Tray_Actions_Types.OPEN &&
      nextProps.isVisible &&
      !this.props.isVisible
    ) {
      this.cardsAnimations = _map(nextProps.items, () => new Animated.Value(0));
      _forEach(this.cardsAnimations, animatedValue => {
        this.startCardAnimation(animatedValue, true);
      });
    }
  }

  onScrollViewLayoutCalculated = event => {
    const displayedContentWidth = event.nativeEvent.layout.width;
    const galleryCardWidth = Metrics.galleryCardWidth + Metrics.galleryCardMargin;
    const numberOfCardsThatCanBeDisplayed = displayedContentWidth / galleryCardWidth;
    const displayedNumberOfCards = Math.floor(numberOfCardsThatCanBeDisplayed);
    this.extraPieceShowedWidth =
      (numberOfCardsThatCanBeDisplayed - displayedNumberOfCards) * galleryCardWidth;
    this.snapToInterval = displayedNumberOfCards * galleryCardWidth;
    this.setState({ displayedNumberOfCards });
  };

  onScrollFlatList = ({ nativeEvent }) => {
    this.scrollX = nativeEvent.contentOffset.x;
  };

  get isExpandedTray() {
    return (
      this.props.subTray &&
      this.props.subTray.subTrayTitle === 'sub_tray_my_products_title' &&
      this.props.trayShouldBeExpandable
    );
  }

  getFlatListStyles = () => {
    const {
      subTray: { withBusinessOverview },
      cardContainerStyle,
    } = this.props;

    return [
      styles.flatListStyle(this.isExpandedTray),
      ...(this.props.withLock ? [{ paddingTop: 10 }] : []),
      ...(!this.isExpandedTray && !withBusinessOverview ? [cardContainerStyle] : []), // eslint-disable-line prettier/prettier
    ];
  };

  getFlatListConfiguration = () => {
    return {
      onScroll: this.onScrollFlatList,
      contentContainerStyle: this.getFlatListStyles(),
      ...(!this.isExpandedTray ? { horizontal: true } : { numColumns: 2 }),
    };
  };

  getExpandedTrayTabs = tabs => {
    const subTrayAllCategory = ContentManager.translate('sub_tray_all_category', [
      this.props.totalItemsCount,
    ]);
    return [subTrayAllCategory, ...tabs];
  };

  startCardAnimation = (itemAnimatedValue, itemVisible = false) => {
    const newToValue = itemVisible ? 1 : 0;

    Animated.timing(itemAnimatedValue, {
      toValue: newToValue,
      delay: newToValue ? cardsOpenBaseDelay : cardsCloseBaseDelay,
      duration: newToValue ? cardOpenDuration : cardCloseDuration,
      useNativeDriver: true,
    }).start();
  };

  _getAnimstionType = (trayAction, index, isLoading) => {
    const translateValue =
      screenWidth +
      (this.props.isVisible ? index : this.cardsAnimations.length + index) *
      Metrics.galleryCardWidth +
      this.scrollX;
    const translateToValue = I18nManager.isRTL ? -translateValue : translateValue;

    const translateX = this.cardsAnimations[index]
      ? this.cardsAnimations[index].interpolate({
        inputRange: [0, 1],
        outputRange: [translateToValue, 0],
        extrapolate: 'clamp',
      })
      : translateToValue;
    if (
      (trayAction === Tray_Actions_Types.OPEN || trayAction === Tray_Actions_Types.CLOSE) &&
      !isLoading
    ) {
      return { transform: [{ translateX }] };
    }
  };

  renderCards = (cards = []) => {
    const { trayAction, isLoading, trayShouldBeExpandable } = this.props;

    if (trayShouldBeExpandable) {
      return cards;
    }

    const baseCards = cards.map((card, index) => {
      const animatedStyle = this._getAnimstionType(trayAction, index, isLoading);

      return (
        <Animated.View key={index} style={animatedStyle} testID={FrameworkTestKeys.AnimationView}>
          {card}
        </Animated.View>
      );
    });
    return baseCards;
  };

  renderDescription = (
    description,
    trayPlaceHolders,
    theme,
    accessibilityID,
    descriptionAnimation,
  ) => {
    return (
      <Animated.View
        style={descriptionAnimation}
        testID={FrameworkTestKeys.subTrayGroupAnimatedViewDescription}
      >
        <VFText
          style={styles.descriptionStyle(theme)}
          i18nKey={description}
          placeHolders={trayPlaceHolders && trayPlaceHolders[description]}
          testKey={accessibilityID}
        />
      </Animated.View>
    );
  };

  renderFooter = () => {
    const { footerWrapperStyle, animations } = this.props;
    return (
      !this.isExpandedTray &&
      _isFunction(this.props.renderFooter) && (
        <Animated.View
          style={[styles.footerAnimatedViewStyle, animations.footerAnimation]}
          testID={FrameworkTestKeys.subTrayGroupFooterAnimatedView}
        >
          <View
            style={[styles.footerContainerStyle, footerWrapperStyle]}
            testID={FrameworkTestKeys.subTrayGroupFooterView}
          >
            {this.props.renderFooter(this.props.subTray, this.props.isLoading)}
          </View>
        </Animated.View>
      )
    );
  };

  renderHeader = (subTray, isLoading, renderHeader, headerAnimation, isExpandedTray) => {
    if (!_isFunction(renderHeader)) {
      return null;
    }
    return (
      <Animated.View
        style={[styles.headerAnimatedViewStyle, headerAnimation]}
        testID={FrameworkTestKeys.subTrayGroupHeaderAnimatedView}
      >
        <View
          style={styles.headerContainerStyle(isExpandedTray)}
          testID={FrameworkTestKeys.subTrayGroupHeaderView}
        >
          {renderHeader(subTray, isLoading)}
        </View>
      </Animated.View>
    );
  };

  renderHeaderBeforeDescription = (
    subTray,
    isLoading,
    renderHeaderBeforeDescription,
    headerAnimation,
    isExpandedTray,
    toggleModal,
  ) => {
    if (!_isFunction(renderHeaderBeforeDescription)) {
      return null;
    }
    return (

      <View
        style={styles.headerContainerStyle(isExpandedTray)}
        testID={FrameworkTestKeys.subTrayGroupHeaderBeforeDescriptionView}
      >
        {renderHeaderBeforeDescription(subTray, isLoading, toggleModal)}
      </View>
    );
  };

  renderTrayContent = () => {
    return (
      <FlatList
        onLayout={this.onScrollViewLayoutCalculated}
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={this.isExpandedTray ? styles.listContentContainer : {}}
        key={this.isExpandedTray ? 'vertical' : 'horizontal'}
        testID={FrameworkTestKeys.SubTrayGroupScroll}
        data={[
          this.renderExpandedTrayHeader(),
          <FlatList
            {...this.getFlatListConfiguration()}
            showsHorizontalScrollIndicator={false}
            data={this.renderCards(this.props.items)}
            renderItem={({ item }) => item}
            testID={FrameworkTestKeys.subTrayGroupSecondFlatList}
          />,
        ]}
        renderItem={({ item }) => item}
      />
    );
  };

  renderExpandedTrayHeader = () => {
    return (
      _isFunction(this.props.expandedTrayItem.onHeaderButtonPress) && (
        <View
          style={styles.headerButtonContainer}
          testID={FrameworkTestKeys.subTrayGroupExpandedTrayHeaderView}
        >
          <VFText
            i18nKey={this.props.expandedTrayItem.headerTitle}
            style={styles.expandedTrayHeaderText(this.props.theme)}
            testKey={FrameworkTestKeys.subTrayGroupExpandedTrayHeaderText}
          />
          <VFButton
            type="secondary"
            title={this.props.expandedTrayItem.headerButtonText}
            style={styles.expandedTrayButton}
            onPress={this.props.expandedTrayItem.onHeaderButtonPress}
            textStyle={styles.expandedTrayButtonTitle}
            testKey={FrameworkTestKeys.subTrayGroupExpandedTrayHeaderButton}
          />
        </View>
      )
    );
  };

  render() {
    const {
      description,
      trayPlaceHolders,
      theme,
      accessibilityID,
      renderHeader,
      renderHeaderBeforeDescription,
      subTray,
      isLoading,
      animations,
      toggleModal,
      scrollableContentContainerStyle,
      descriptionContainerStyle,
      getCategoryName,
      expandedTrayItems,
      onSelectedTab,
    } = this.props;

    const { descriptionAnimation, cardsAnimation, headerAnimation } = animations;
    const { renderCustomContent } = subTray;

    return (
      <View
        style={styles.containerStyle(this.isExpandedTray)}
        testID={FrameworkTestKeys.Description}
      >
        {this.renderHeaderBeforeDescription(
          subTray,
          isLoading,
          renderHeaderBeforeDescription,
          headerAnimation,
          this.isExpandedTray,
          toggleModal,
        )}
        <View
          testID={FrameworkTestKeys.DescriptionView}
          style={[
            styles.descriptionContainer(this.isExpandedTray, subTray.withBusinessOverview),
            descriptionContainerStyle,
          ]}
        >
          {this.renderDescription(
            description,
            trayPlaceHolders,
            theme,
            accessibilityID,
            descriptionAnimation,
          )}
        </View>
        {this.renderHeader(subTray, isLoading, renderHeader, headerAnimation, this.isExpandedTray)}
        <Animated.View style={[cardsAnimation, { overflow: 'hidden' }]} testID={FrameworkTestKeys.subTrayGroupAnimatedView}>
          {_isFunction(renderCustomContent) ? (
            renderCustomContent(subTray, isLoading)
          ) : (
            <View
              style={[
                styles.scrollableContentStyle(theme, this.isExpandedTray),
                scrollableContentContainerStyle,
              ]}
              testID={FrameworkTestKeys.subTrayGroupView}
            >
              {this.isExpandedTray && (
                <View style={styles.tabsContainer} testID={FrameworkTestKeys.subTrayGroupTabsView}>
                  <Tabs
                    scrollable
                    valueExtractor={getCategoryName}
                    data={this.getExpandedTrayTabs(expandedTrayItems)}
                    onSelectedTab={onSelectedTab}
                    testID={FrameworkTestKeys.subTrayGroupTabs}
                  />
                </View>
              )}
              {this.renderTrayContent()}
            </View>
          )}
        </Animated.View>
        <View
          style={styles.bottomBarBackground(theme, this.isExpandedTray)}
          testID={FrameworkTestKeys.subTrayGroupBottomBarView}
        />
        {this.renderFooter()}
      </View>
    );
  }
}

SubTrayGroup.defaultProps = {
  close: () => { },
  theme: LightThemeColors,
  animations: {},
  withLock: false,
  expandedTrayItem: {},
};

SubTrayGroup.propTypes = {
  items: PropTypes.array.isRequired,
  subTray: PropTypes.object.isRequired,
  description: PropTypes.string.isRequired,
  isVisible: PropTypes.bool,
  notificationCount: PropTypes.number,
  trayAction: PropTypes.string,
  isLoading: PropTypes.bool,
  trayPlaceHolders: PropTypes.object,
  theme: PropTypes.object,
  renderFooter: PropTypes.func,
  cardContainerStyle: ViewPropTypes.style,
  accessibilityID: PropTypes.string,
  animations: PropTypes.shape({
    descriptionAnimation: PropTypes.object,
    cardsAnimation: PropTypes.object,
    footerAnimation: PropTypes.object,
    headerAnimation: PropTypes.object,
  }),
  isExpandedTrayEnabled: PropTypes.bool,
  expandedTrayItems: PropTypes.array,
  expandedTrayHeight: PropTypes.func,
  getCategoryName: PropTypes.func,
  trayShouldBeExpandable: PropTypes.bool,
  onSelectedTab: PropTypes.func,
  expandedTrayItem: PropTypes.shape({
    onHeaderButtonPress: PropTypes.func,
    headerTitle: PropTypes.string,
    headerButtonText: PropTypes.string,
  }),
  totalItemsCount: PropTypes.number,
  renderHeader: PropTypes.func,
  renderHeaderBeforeDescription: PropTypes.func,
  toggleModal: PropTypes.func,
  withLock: PropTypes.bool,
  scrollableContentContainerStyle: ViewPropTypes.style,
  descriptionContainerStyle: ViewPropTypes.style,
  footerWrapperStyle: ViewPropTypes.style,
};

export default withTheme(SubTrayGroup);
